import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { DiaryEntrySyncStatus } from 'graphql/types';
import { SmartDiaryEntry } from '../../type';

export const useSmartDiaryCount = (smartEntries: SmartDiaryEntry[]): number => {
  const sdKeys = useMemo(() => smartEntries.map((entry) => entry.id), [
    smartEntries
  ]);
  const { watch } = useFormContext();
  const deletePendingCount = useMemo(
    () =>
      smartEntries.filter(
        (entry) => entry.syncStatus === DiaryEntrySyncStatus.DeletePending
      ).length,
    [smartEntries]
  );

  const formValues = watch(sdKeys);
  const result = useMemo<Record<string, boolean>>(
    () =>
      sdKeys.reduce(
        (acc, item, index) => ({
          ...acc,
          [`${item}`]: formValues[index] ?? false
        }),
        {}
      ),
    [sdKeys, formValues]
  );

  const selectedCount = useMemo(
    () => sdKeys.filter((key) => result[key] === true).length,
    [sdKeys, result]
  );

  return useMemo(() => selectedCount + deletePendingCount, [
    deletePendingCount,
    selectedCount
  ]);
};
